import { Helmet } from "react-helmet-async";
import { DEFAULT_OG_IMAGE, SITE_NAME, absoluteUrl } from "../lib/seo";

function Seo({ title, description, path = "/", image = DEFAULT_OG_IMAGE, noindex = false, jsonLd }) {
  const alreadyHasSiteName = title?.trim().toLowerCase().endsWith(SITE_NAME.toLowerCase());
  const fullTitle = !title
    ? `${SITE_NAME} | Best Fencing Contractor in Perth`
    : alreadyHasSiteName
    ? title
    : `${title} | ${SITE_NAME}`;
  const url = absoluteUrl(path);
  const jsonLdList = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />

      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {jsonLdList.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}

export default Seo;
